import styled from 'styled-components'
import { GREEN, GREY_DARK, RED } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const Outside = styled.div`
  .info, .error {
    margin-top: -5px;
    margin-bottom: 17px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 12px;
    display: block;
    a {
      color: inherit;
    }
  }

  .error {
    color: ${RED};
    margin-top: -10px;
  }

  margin-bottom: 34px;
`

export const Container = styled.div`
  label {
    display: block;
    position: relative;
    margin-bottom: 14px;
    color: ${GREY_DARK};
    font-size: 18px;
    line-height: 26px;

    .right_attachment {
      position: absolute;
      right: 0;
      top: 0;

      @media (max-width: ${MD}) {
        display: block;
        text-align: right;
        position: initial;
      }
    }
  }

  .input_radio_options {
    display: flex;
    flex-wrap: wrap;
  }
`
export const InputElement = styled.div`
  input {
    display: none;

    &:checked + label {
      color: ${GREEN};
      span {
        border-color: ${GREEN};
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 4px;
          top: 4px;
          width: 10px;
          height: 10px;
          border-radius: 100%;
          background: ${GREEN};
        }
      }
    }
  }

  display: flex;


  label {
    cursor: pointer;
    margin-right: 25px;
    display: flex;
    align-items: center;
    font-size: 14px;

    span {
      display: inline-block;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      flex-grow: 0;
      margin: 0 10px 0 0;
      border: solid 1px ${GREY_DARK};
    }
  }
`
